import React from 'react';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import { PageName } from '../../shared/types';

type Props = {
  milestones: Item[];
  pageName: PageName;
};

const MilestoneDropdown = ({ milestones, pageName }: Props) => {
  const { watch, setValue } = useFormContext();
  const selectedMilestone: Item = watch('milestone');

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  return (
    <SimpleSingleDropdown
      label={t('milestone_reached')}
      data-provides="talent-rediscovery-milestone-reached"
      clearable
      items={milestones}
      selectedItem={selectedMilestone}
      onSelectedItemChange={(val) =>
        setValue('milestone', val, { shouldDirty: true })
      }
    />
  );
};

export default MilestoneDropdown;
